// @flow

import PrimaryPalette from './colors';

const Colors = {
  hover: PrimaryPalette.extraLightIris,
  selected: PrimaryPalette.lightGrey,
  error: PrimaryPalette.mediumPoppy,
};

const Tokens = {
  colors: Colors,
};

export type Color = $Values<typeof Tokens>;

export default Tokens;
